import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href", "target"]
const _hoisted_2 = {
  key: 0,
  class: "link__content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: $props.link,
    target: $props.target,
    class: _normalizeClass(["link", [`link--${$props.skin}`, `link--${$props.size}`]])
  }, [
    ($props.text && $props.text.length > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($props.text), 1))
      : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
  ], 10, _hoisted_1))
}